module.exports = __webpack_public_path__ + "img/yw.6fbe474e.png";